import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, Fragment as _Fragment } from "vue"
import _imports_0 from '@/assets/icons/Spin.svg'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-plus" }, null, -1)
const _hoisted_2 = {
  key: 0,
  class: "my-3 d-flex justify-content-center"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "",
  class: "btn-spin"
}, null, -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { class: "mt-3" }

import Modal from './../Modal.vue';
import AntecedentForm from './AntecedentForm.vue';
import { useVuelidate } from '@vuelidate/core'
import { required } from '@vuelidate/validators'

import { ref, reactive, computed } from 'vue'
import { useStore } from 'vuex'


export default /*#__PURE__*/_defineComponent({
  __name: 'CreateAntecedent',
  props: {
    id: {
        type: Number,
        required: true
    },
    teleconsultation_id: {
        type: Number,
        required: true
    },
},
  setup(__props) {

const props = __props

const store = useStore();
const newAnt = ref(false);

let state = reactive({
    type: {},
    description: "",
    date: null,
    dossier_medical_id: props.id,
    teleconsultation_id: props.teleconsultation_id
})

const rules = computed(() => {
    return {
        description: {required},
        type: {required},
        date: { required }
    }
})

const v$ = useVuelidate(rules, state)



const viewAntecedant = () =>{
    newAnt.value = true
}

const createAntecedent = function(state: {}){
    v$.value.$validate()
    if(!v$.value.$error){
        store.dispatch('patient/createAntecedent', state).then(() => {
            newAnt.value = false;
            state = {
                type: {},
                description: "",
                date: null,
                dossier_medical_id: props.id,
                teleconsultation_id: props.teleconsultation_id
            }
        })
    }else{
        //console.log(v$.value)
    }

}

const loader = computed(() => store.state.patient.loadingStatus)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("button", {
      type: "button",
      onClick: viewAntecedant,
      class: "btn border d-flex align-items-center gap-1 m-2"
    }, [
      _hoisted_1,
      _createTextVNode(" Ajouter")
    ]),
    _createVNode(Modal, {
      modelValue: newAnt.value,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((newAnt).value = $event)),
      title: "Nouvel antécédent",
      bgcolor: "#172b4d",
      colorTitle: "white",
      width: "lg"
    }, {
      default: _withCtx(() => [
        (loader.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_4))
          : _createCommentVNode("", true),
        (!loader.value)
          ? (_openBlock(), _createElementBlock("form", _hoisted_5, [
              _createVNode(AntecedentForm, {
                state: _unref(state),
                v$: _unref(v$)
              }, null, 8, ["state", "v$"]),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("button", {
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (createAntecedent(_unref(state)))),
                  type: "submit",
                  class: "btn btn-primary"
                }, "Enregistrer")
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})